import src from "IMAGE";
export default { src, width: 1480, height: 352, blurWidth: 0, blurHeight: 0};
